import React, { FC, useState } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import MediaCard from "./Card";
import Button from "components/Button";
import Carousel from "components/Carousel";

import { ReactComponent as FactsLogo } from "assets/images/landing/mediaLogos/facts-logo.svg";
import { ReactComponent as GazetaLogo } from "assets/images/landing/mediaLogos/gazeta-logo.svg";
import { ReactComponent as InterfaxLogo } from "assets/images/landing/mediaLogos/interfax-logo.svg";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

import { styles } from "./styles";

const publications = [
  {
    source: "GAZETA.UA",
    logo: <GazetaLogo />,
    title:
      "ІBAN oplata - це інноваційний український онлайн-сервіс. Він дозволяє приймати оплату за допомогою платіжних посилань і QR-кодів.",
    link: "https://gazeta.ua/articles/promotion/_iban-oplata-novij-standart-bezgotivkovih-oplat/1241600",
  },
  {
    source: "ІНТЕРФАКС-УКРАЇНА",
    logo: <InterfaxLogo />,
    title:
      "IBAN oplata дозволяє проводити оплату за допомогою платіжних посилань і QR-кодів.",
    link: "https://interfax.com.ua/news/promo/1137510.html",
  },
  {
    source: "ФАКТИ",
    logo: <FactsLogo />,
    title:
      "Чому карткові перекази більше не актуальні: перехід бізнесу на IBAN oplata у 2026 році",
    link: "https://fakty.com.ua/ua/ukraine/ekonomika/20260415-chomu-kartkovi-perekazy-bilshe-ne-aktualni-perehid-biznesu-na-iban-oplata-u-2026-roczi/",
  },
];

const MediaPublications: FC = () => {
  const [showMore, setShowMore] = useState(false);

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const onCarouselNavigate = (direction: "left" | "right") => {
    analytics().sendConversionEvent(
      AnalyticsEvents.iban_oplata_media_carousel_navigate,
      { direction },
      true,
    );
  };

  const onShowMoreClick = () => {
    analytics().sendConversionEvent(
      AnalyticsEvents.iban_oplata_media_show_more,
      null,
      true,
    );
    setShowMore(true);
  };

  return (
    <Box sx={styles.sectionBackground}>
      <Container>
        <Typography variant="subtitle1" color="error.dark">
          Публікації у медіа
        </Typography>
        <Typography variant="h2" color="primary" sx={{ mt: 2.5, mb: 7.5 }}>
          Про нас пишуть
        </Typography>

        {isDesktop ? (
          <Carousel
            items={publications}
            visibleCount={2}
            step={1}
            getItemKey={(pub) => pub.source}
            renderItem={(pub) => <MediaCard {...pub} />}
            onNavigate={onCarouselNavigate}
          />
        ) : (
          <>
            <Stack sx={styles.cardsRow}>
              {publications.slice(0, 2).map((pub) => (
                <MediaCard key={pub.source} {...pub} />
              ))}

              {showMore &&
                publications
                  .slice(2)
                  .map((pub) => <MediaCard key={pub.source} {...pub} />)}
            </Stack>

            {!showMore && publications.length >= 3 && (
              <Button
                color="secondary"
                variant="contained"
                onClick={onShowMoreClick}
                sx={{ mt: 2 }}
                fullWidth
                withBorder
              >
                Показати більше
              </Button>
            )}
          </>
        )}
      </Container>
    </Box>
  );
};

export default MediaPublications;
